import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDpRlP1Uw-eV18peefU9eaPonYvxDcdYuw",
  authDomain: "nysmah-d57d0.firebaseapp.com",
  projectId: "nysmah-d57d0",
  storageBucket: "nysmah-d57d0.firebasestorage.app",
  messagingSenderId: "551438318678",
  appId: "1:551438318678:web:ee3b90ec05670df5da0ff7",
  measurementId: "G-HTX6VKS86V"
};

export const fireStore = initializeApp(firebaseConfig);
